import type { PropsWithChildren } from 'react';
import { AuthProvider } from './AuthProvider';
import { FirebaseProvider } from './FirebaseProvider';
import { LibraryProvider } from './LibraryProvider';
import { SyncStatusProvider } from './SyncStatusProvider';

export function AppProviders({ children }: PropsWithChildren): React.JSX.Element {
  return (
    <FirebaseProvider>
      <AuthProvider>
        <SyncStatusProvider>
          <LibraryProvider>{children}</LibraryProvider>
        </SyncStatusProvider>
      </AuthProvider>
    </FirebaseProvider>
  );
}
